import { useState, useRef, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import NovoEvento from "./NovoEvento";
import { GOLD, BLUE, TEMAS } from "../constants/temas";
import { eventos as eventosAPI } from "../Api";  // ← ADICIONADO

const TIPO_CONFIG = {
    Culto:       { icon: "✝️",  grad: "135deg, #1a3a6c 0%, #0f1729 100%", accent: "#4a90d9" },
    Célula:      { icon: "🏠",  grad: "135deg, #1a4a2e 0%, #0f1729 100%", accent: "#4caf50" },
    Ensaio:      { icon: "🎸",  grad: "135deg, #3a2a0f 0%, #0f1729 100%", accent: "#F9A826" },
    Conferência: { icon: "🎤",  grad: "135deg, #3a1a4a 0%, #0f1729 100%", accent: "#9c27b0" },
    Outro:       { icon: "📌",  grad: "135deg, #1a2a3a 0%, #0f1729 100%", accent: "#607d8b" },
};

const FUNCOES = ["Vocal", "Violão", "Guitarra", "Baixo", "Teclado", "Bateria", "Soprano", "Contralto", "Tenor", "Barítono", "Outro"];

function diasRestantes(dataStr) {
    const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
    const ev = new Date(dataStr + "T00:00:00");
    const diff = Math.round((ev - hoje) / 86400000);
    if (diff === 0) return { label: "Hoje",   urgente: true,  passado: false };
    if (diff === 1) return { label: "Amanhã", urgente: true,  passado: false };
    if (diff < 0)   return { label: `Há ${Math.abs(diff)}d`, urgente: false, passado: true };
    return { label: `Em ${diff} dias`, urgente: false, passado: false };
}

function BadgeDias({ data }) {
    const { label, urgente, passado } = diasRestantes(data);
    const bg    = passado ? "#ffffff10" : urgente ? `${GOLD}22` : "#ffffff10";
    const color = passado ? "#ffffff35" : urgente ? GOLD        : "#ffffff60";
    const border= passado ? "#ffffff08" : urgente ? `${GOLD}44` : "#ffffff15";
    return (
        <span style={{ fontSize: 10, fontWeight: 700, padding: "3px 9px", borderRadius: 20, background: bg, color, border: `1px solid ${border}` }}>
            {label}
        </span>
    );
}

function Avatar({ membro, size = 30, overlap = false }) {
    return (
        <div style={{
            width: size, height: size, borderRadius: "50%", overflow: "hidden",
            border: "2px solid #0f1729", marginLeft: overlap ? -8 : 0, flexShrink: 0,
            background: `${GOLD}22`, display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: size * 0.38,
        }}>
            {membro.foto
                ? <img src={membro.foto} alt={membro.nome} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                : <span>🎵</span>}
        </div>
    );
}

// ── Modal de confirmação de exclusão ──────────────────────────────────────────
function ModalConfirmarExclusao({ visivel, titulo, descricao, onConfirmar, onCancelar, loading }) {
    useEffect(() => {
        document.body.style.overflow = visivel ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [visivel]);

    if (!visivel) return null;

    return createPortal(
        <div
            onClick={onCancelar}
            style={{
                position: "fixed", inset: 0, zIndex: 99999,
                background: "rgba(0,0,0,0.80)",
                backdropFilter: "blur(6px)",
                WebkitBackdropFilter: "blur(6px)",
                display: "flex", alignItems: "center", justifyContent: "center",
                padding: 24,
                animation: "mcFadeIn 0.2s ease",
            }}
        >
            <style>{`
                @keyframes mcFadeIn { from { opacity:0 } to { opacity:1 } }
                @keyframes mcSlideUp { from { opacity:0; transform:translateY(20px) scale(0.97) } to { opacity:1; transform:translateY(0) scale(1) } }
            `}</style>
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: "#1a2540",
                    border: "1px solid #2a3a5c",
                    borderRadius: 22,
                    padding: "28px 24px 24px",
                    width: "100%", maxWidth: 340,
                    boxShadow: "0 24px 60px rgba(0,0,0,0.7)",
                    animation: "mcSlideUp 0.25s cubic-bezier(.34,1.56,.64,1)",
                    textAlign: "center",
                }}
            >
                {/* Ícone */}
                <div style={{
                    width: 60, height: 60, borderRadius: "50%",
                    background: "rgba(244,67,54,0.12)",
                    border: "2px solid rgba(244,67,54,0.3)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 26, margin: "0 auto 16px",
                }}>⚠️</div>

                <div style={{ fontSize: 17, fontWeight: 800, color: "#fff", marginBottom: 10 }}>
                    {titulo}
                </div>
                <div style={{ fontSize: 13, color: "#8899bb", lineHeight: 1.6, marginBottom: 26 }}>
                    {descricao}
                </div>

                <div style={{ display: "flex", gap: 10 }}>
                    <button
                        onClick={onCancelar}
                        disabled={loading}
                        style={{
                            flex: 1, padding: "13px 0", borderRadius: 12,
                            background: "#0f1729", border: "1px solid #2a3a5c",
                            color: "#8899bb", fontWeight: 600, fontSize: 14,
                            cursor: "pointer",
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirmar}
                        disabled={loading}
                        style={{
                            flex: 1, padding: "13px 0", borderRadius: 12,
                            background: loading ? "#555" : "linear-gradient(135deg,#f44336,#d32f2f)",
                            border: "none", color: "white",
                            fontWeight: 800, fontSize: 14, cursor: loading ? "default" : "pointer",
                            boxShadow: loading ? "none" : "0 4px 16px rgba(244,67,54,0.4)",
                        }}
                    >
                        {loading ? "Excluindo..." : "🗑 Excluir"}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

// ── Seção: Paleta de Cores ────────────────────────────────────────────────────
function PaletaCores({ ev, setEscala, adminMode, perfilNome, tema: T }) {
    const podeEnviar = adminMode || ev.responsavelPaleta === perfilNome;
    const foto = ev.fotoPaleta || ev.foto_look || null;

    // Salva foto da paleta no backend
    const persistirPaleta = (dadosAtualizados) => {
        const eventoAtualizado = { ...ev, ...dadosAtualizados };
        // Atualiza estado local imediatamente (normaliza para fotoPaleta)
        setEscala(prev => prev.map(x =>
            x.id === ev.id ? { ...eventoAtualizado, fotoPaleta: eventoAtualizado.fotoPaleta || eventoAtualizado.foto_look } : x
        ));
        // Persiste no backend
        const fotoParaSalvar = dadosAtualizados.fotoPaleta !== undefined
            ? dadosAtualizados.fotoPaleta
            : (ev.fotoPaleta || ev.foto_look || null);
        eventosAPI.atualizar(ev.id, {
            titulo: ev.titulo,
            tipo: ev.tipo,
            data: ev.data,
            fotoPaleta: fotoParaSalvar,
            responsavelPaleta: dadosAtualizados.responsavelPaleta !== undefined
                ? dadosAtualizados.responsavelPaleta
                : (ev.responsavelPaleta || null),
        }).then(() => {
            console.log("Paleta salva com sucesso");
        }).catch(err => {
            console.warn("Erro ao salvar paleta:", err);
        });
    };

    const onUpload = e => {
        const file = e.target.files[0]; if (!file) return;
        // Comprime a imagem antes de salvar (max 800px, qualidade 0.7)
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
            const MAX = 800;
            const canvas = document.createElement("canvas");
            const ratio = Math.min(MAX / img.width, MAX / img.height, 1);
            canvas.width = Math.round(img.width * ratio);
            canvas.height = Math.round(img.height * ratio);
            canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
            const base64 = canvas.toDataURL("image/jpeg", 0.7);
            URL.revokeObjectURL(url);
            persistirPaleta({ fotoPaleta: base64 });
        };
        img.src = url;
    };

    const remover = () => persistirPaleta({ fotoPaleta: null });

    const definirResponsavel = (nome) => persistirPaleta({ responsavelPaleta: nome });

    return (
        <div style={{ marginBottom: 18 }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                <div style={{ fontSize: 10, fontWeight: 700, color: T.textoSecundario, textTransform: "uppercase", letterSpacing: 1.2 }}>
                    👗 Paleta de Cores
                </div>
            </div>

            {foto ? (
                <div style={{ position: "relative", borderRadius: 14, overflow: "hidden" }}>
                    <img src={foto} alt="Paleta de cores" style={{ width: "100%", height: 220, objectFit: "cover", display: "block", borderRadius: 14 }} />
                    <div style={{ position: "absolute", top: 10, left: 10, background: "rgba(0,0,0,0.65)", borderRadius: 20, padding: "4px 12px", fontSize: 11, color: "#ffffffcc", fontWeight: 600 }}>
                        👗 Look do evento
                    </div>
                    {podeEnviar && (
                        <div style={{ position: "absolute", top: 10, right: 10, display: "flex", gap: 6 }}>
                            <label style={{ background: "rgba(0,0,0,0.65)", border: "none", borderRadius: 20, padding: "4px 12px", fontSize: 11, color: GOLD, cursor: "pointer", fontWeight: 700 }}>
                                🔄 Trocar
                                <input type="file" accept="image/*" style={{ display: "none" }} onChange={onUpload} />
                            </label>
                            {adminMode && (
                                <button onClick={remover} style={{ background: "rgba(0,0,0,0.65)", border: "none", borderRadius: "50%", width: 28, height: 28, color: "#ff6b6b", fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
                            )}
                        </div>
                    )}
                </div>
            ) : (
                podeEnviar ? (
                    <label style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 6, background: T.bgCardSecundario, border: `2px dashed ${T.borda}`, borderRadius: 14, padding: "28px 0", cursor: "pointer" }}>
                        <span style={{ fontSize: 32 }}>👗</span>
                        <span style={{ fontSize: 13, color: T.textoSecundario, fontWeight: 700 }}>{adminMode ? "Enviar foto da paleta" : "Enviar sua sugestão de look"}</span>
                        <span style={{ fontSize: 11, color: T.textoSecundario, opacity: 0.5 }}>Escolha uma foto da sua galeria</span>
                        <input type="file" accept="image/*" style={{ display: "none" }} onChange={onUpload} />
                    </label>
                ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: 10, background: T.bgCardSecundario, borderRadius: 14, padding: "16px", border: `1px solid ${T.borda}` }}>
                        <span style={{ fontSize: 24 }}>👗</span>
                        <div>
                            <div style={{ fontSize: 13, color: T.textoSecundario, fontWeight: 600 }}>Sem paleta definida</div>
                            <div style={{ fontSize: 11, color: T.textoSecundario, opacity: 0.6 }}>
                                {ev.responsavelPaleta ? `Aguardando ${ev.responsavelPaleta} enviar` : "O admin ainda não definiu a paleta"}
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    );
}

// ── Seção: Equipe do evento ───────────────────────────────────────────────────
function EquipeEvento({ ev, membros, setEscala, adminMode, tema: T }) {
    const integrantes = ev.integrantes || [];

    const toggleMembro = (m) => {
        const jaEsta = integrantes.find(x => x.nome === m.nome);
        const novos = jaEsta
            ? integrantes.filter(x => x.nome !== m.nome)
            : [...integrantes, m];

        // FIX: atualiza estado local E persiste no backend
        setEscala(prev => prev.map(x => x.id === ev.id ? { ...x, integrantes: novos } : x));
        eventosAPI.atualizar(ev.id, { ...ev, integrantes: novos }).catch(err =>
            console.warn("Erro ao salvar equipe:", err)
        );
    };

    return (
        <div style={{ marginBottom: 18 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: T.textoSecundario, textTransform: "uppercase", letterSpacing: 1.2, marginBottom: 10 }}>
                👥 Equipe escalada {integrantes.length > 0 && `(${integrantes.length})`}
            </div>

            {membros.length === 0 ? (
                <div style={{ fontSize: 12, color: T.textoSecundario, background: T.bgCardSecundario, borderRadius: 10, padding: "10px 14px", border: `1px solid ${T.borda}` }}>
                    Nenhum membro cadastrado. Adicione membros na lista acima.
                </div>
            ) : (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {membros.map((m, i) => {
                        const selecionado = !!integrantes.find(x => x.nome === m.nome);
                        return (
                            <button
                                key={i}
                                onClick={() => adminMode && toggleMembro(m)}
                                style={{
                                    display: "flex", alignItems: "center", gap: 7,
                                    background: selecionado ? `${GOLD}20` : T.bgCardSecundario,
                                    borderRadius: 20, padding: "6px 12px 6px 6px",
                                    border: `2px solid ${selecionado ? GOLD : T.borda}`,
                                    cursor: adminMode ? "pointer" : "default",
                                    transition: "all 0.15s",
                                }}
                            >
                                <Avatar membro={m} size={26} />
                                <div style={{ textAlign: "left" }}>
                                    <div style={{ fontSize: 12, fontWeight: 700, color: selecionado ? GOLD : T.texto }}>{m.nome}</div>
                                    {m.funcao && <div style={{ fontSize: 10, color: selecionado ? GOLD : T.textoSecundario, opacity: 0.8 }}>{m.funcao}</div>}
                                </div>
                                {selecionado && <span style={{ fontSize: 12, color: GOLD, marginLeft: 2 }}>✓</span>}
                            </button>
                        );
                    })}
                </div>
            )}
            {adminMode && membros.length > 0 && (
                <div style={{ fontSize: 11, color: T.textoSecundario, marginTop: 8, opacity: 0.6 }}>
                    Toque para escalar / remover da equipe
                </div>
            )}
        </div>
    );
}

// ── Modo Culto do Evento ──────────────────────────────────────────────────────
function ModoCultoEvento({ setlist, musicasBase, onFechar }) {
    const [idx, setIdx] = useState(0);
    const [velocidade, setVelocidade] = useState(2);
    const [rolando, setRolando] = useState(false);
    const containerRef = useRef(null);
    const rafRef = useRef(null);
    const lastTimeRef = useRef(null);
    const VEL_PX_S = [25, 50, 90, 150, 250];

    const musica = useMemo(() => {
        const s = setlist[idx];
        if (!s) return null;
        const base = musicasBase?.find(m => m.id === s.id) || {};
        return { ...s, ...base };
    }, [idx, setlist, musicasBase]);

    const cifra = musica?.cifra || "";
    const partituraUrl = musica?.partituraUrl || null;
    const partituranome = musica?.partituranome || null;
    const temCifra = !!cifra.trim();
    const temPartitura = !!partituraUrl;
    const isPDF = partituraUrl && (partituranome?.toLowerCase().endsWith(".pdf") || partituraUrl.startsWith("blob:"));

    const [modo, setModo] = useState("cifra");

    useEffect(() => {
        setRolando(false);
        lastTimeRef.current = null;
        if (containerRef.current) containerRef.current.scrollTop = 0;
        setModo(prev => {
            if (prev === "cifra" && !temCifra && temPartitura) return "partitura";
            if (prev === "partitura" && !temPartitura && temCifra) return "cifra";
            return prev;
        });
    }, [idx]);

    useEffect(() => {
        if (!rolando || modo !== "cifra") { cancelAnimationFrame(rafRef.current); lastTimeRef.current = null; return; }
        const loop = (ts) => {
            if (lastTimeRef.current === null) lastTimeRef.current = ts;
            const dt = (ts - lastTimeRef.current) / 1000;
            lastTimeRef.current = ts;
            if (containerRef.current) {
                containerRef.current.scrollTop += VEL_PX_S[velocidade - 1] * dt;
                const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
                if (scrollTop + clientHeight >= scrollHeight - 10) { setRolando(false); return; }
            }
            rafRef.current = requestAnimationFrame(loop);
        };
        rafRef.current = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(rafRef.current); lastTimeRef.current = null; };
    }, [rolando, velocidade, modo]);

    const irPara = (novoIdx) => {
        setIdx(Math.max(0, Math.min(setlist.length - 1, novoIdx)));
        setRolando(false);
    };

    if (!musica) return null;

    return createPortal(
        <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "#060c1a", zIndex: 99999, display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div style={{ background: "#0a1020", borderBottom: "1px solid #ffffff12", padding: "10px 14px", display: "flex", alignItems: "center", gap: 8, flexShrink: 0, flexWrap: "wrap" }}>
                <div style={{ display: "flex", background: "#ffffff0d", borderRadius: 8, padding: 2, gap: 2 }}>
                    <button onClick={() => { setModo("cifra"); setRolando(false); }} disabled={!temCifra}
                            style={{ padding: "5px 12px", borderRadius: 6, border: "none", background: modo === "cifra" ? GOLD : "transparent", color: modo === "cifra" ? BLUE : (temCifra ? "#ffffff70" : "#ffffff20"), fontSize: 12, fontWeight: 700, cursor: temCifra ? "pointer" : "default" }}>
                        🎸 Cifra
                    </button>
                    <button onClick={() => { setModo("partitura"); setRolando(false); }} disabled={!temPartitura}
                            style={{ padding: "5px 12px", borderRadius: 6, border: "none", background: modo === "partitura" ? GOLD : "transparent", color: modo === "partitura" ? BLUE : (temPartitura ? "#ffffff70" : "#ffffff20"), fontSize: 12, fontWeight: 700, cursor: temPartitura ? "pointer" : "default" }}>
                        📄 Partitura
                    </button>
                </div>
                {modo === "cifra" && temCifra && (
                    <>
                        <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
                            <span style={{ fontSize: 10, color: "#ffffff30" }}>VEL</span>
                            {[1,2,3,4,5].map(v => (
                                <button key={v} onClick={() => setVelocidade(v)} style={{ width: 28, height: 28, borderRadius: 6, border: "none", background: velocidade === v ? GOLD : "#ffffff12", color: velocidade === v ? BLUE : "#ffffff60", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>{v}</button>
                            ))}
                        </div>
                        <button onClick={() => setRolando(p => !p)} style={{ background: rolando ? "#ff4444" : GOLD, border: "none", borderRadius: 20, padding: "6px 16px", color: rolando ? "white" : BLUE, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
                            {rolando ? "⏸" : "▶"}
                        </button>
                    </>
                )}
                <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 6 }}>
                    <button onClick={() => irPara(idx - 1)} disabled={idx === 0}
                            style={{ width: 36, height: 36, borderRadius: 10, border: "none", background: idx === 0 ? "#ffffff08" : "#ffffff15", color: idx === 0 ? "#ffffff20" : "white", fontSize: 20, cursor: idx === 0 ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>‹</button>
                    <div style={{ textAlign: "center", minWidth: 36 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: GOLD }}>{idx + 1}/{setlist.length}</div>
                        <div style={{ fontSize: 9, color: "#ffffff30", maxWidth: 60, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{musica.titulo}</div>
                    </div>
                    <button onClick={() => irPara(idx + 1)} disabled={idx >= setlist.length - 1}
                            style={{ width: 36, height: 36, borderRadius: 10, border: "none", background: idx >= setlist.length - 1 ? "#ffffff08" : GOLD, color: idx >= setlist.length - 1 ? "#ffffff20" : BLUE, fontSize: 20, cursor: idx >= setlist.length - 1 ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>›</button>
                    <button onClick={onFechar} style={{ background: "#ffffff15", border: "none", borderRadius: "50%", width: 34, height: 34, color: "white", fontSize: 18, cursor: "pointer", marginLeft: 4 }}>✕</button>
                </div>
            </div>
            {modo === "cifra" ? (
                temCifra ? (
                    <div ref={containerRef} style={{ flex: 1, overflowY: "auto", padding: "22px 18px", background: "#060c1a" }}>
                        <div style={{ fontFamily: "monospace", fontSize: 17, lineHeight: 2.3, color: "white" }}>
                            {cifra.split("\n").map((linha, i) => {
                                if (linha.startsWith("[")) return <div key={i} style={{ color: GOLD, fontWeight: 700, marginTop: 20, marginBottom: 4, fontSize: 13, letterSpacing: 1 }}>{linha}</div>;
                                return <div key={i} style={{ whiteSpace: "pre" }}>{linha || "\u00a0"}</div>;
                            })}
                            <div style={{ height: 200 }} />
                        </div>
                        {rolando && (
                            <div style={{ position: "fixed", bottom: 20, left: "50%", transform: "translateX(-50%)", background: `${GOLD}22`, border: `1px solid ${GOLD}44`, borderRadius: 20, padding: "5px 16px", fontSize: 11, color: GOLD, fontWeight: 700, pointerEvents: "none" }}>▼ vel {velocidade}</div>
                        )}
                    </div>
                ) : (
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "#ffffff30" }}>
                        <span style={{ fontSize: 44 }}>🎵</span>
                        <span style={{ fontSize: 14 }}>Sem cifra disponível</span>
                    </div>
                )
            ) : (
                temPartitura ? (
                    isPDF
                        ? <LeitorPDFEvento url={partituraUrl} />
                        : <div style={{ flex: 1, overflow: "auto", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: 12 }}>
                            <img src={partituraUrl} alt="Partitura" style={{ maxWidth: "100%", borderRadius: 8, boxShadow: "0 4px 20px #0006" }} />
                        </div>
                ) : (
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "#ffffff30" }}>
                        <span style={{ fontSize: 44 }}>📄</span>
                        <span style={{ fontSize: 14 }}>Sem partitura disponível</span>
                    </div>
                )
            )}
        </div>,
        document.body
    );
}

// ── LeitorPDF para o Escala ───────────────────────────────────────────────────
function LeitorPDFEvento({ url }) {
    const [paginas, setPaginas] = useState([]);
    const [total, setTotal] = useState(0);
    const [carregando, setCarregando] = useState(true);
    const [progresso, setProgresso] = useState(0);
    const [zoom, setZoom] = useState(1);
    const [paginaAtual, setPaginaAtual] = useState(1);
    const scrollRef = useRef(null);

    useEffect(() => {
        if (!url) return;
        setPaginas([]); setTotal(0); setCarregando(true); setProgresso(0); setPaginaAtual(1);
        const carregar = async () => {
            try {
                const pdfjsLib = window["pdfjs-dist/build/pdf"];
                pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
                const pdf = await pdfjsLib.getDocument({ url, cMapUrl: "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/cmaps/", cMapPacked: true }).promise;
                setTotal(pdf.numPages);
                const imgs = [];
                for (let i = 1; i <= pdf.numPages; i++) {
                    const page = await pdf.getPage(i);
                    const scale = (window.innerWidth / page.getViewport({ scale: 1 }).width) * 2;
                    const viewport = page.getViewport({ scale: Math.min(scale, 4) });
                    const canvas = document.createElement("canvas");
                    canvas.width = viewport.width; canvas.height = viewport.height;
                    await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
                    imgs.push(canvas.toDataURL("image/jpeg", 0.92));
                    setProgresso(Math.round((i / pdf.numPages) * 100));
                }
                setPaginas(imgs); setCarregando(false);
            } catch { setCarregando(false); setPaginas(["erro"]); }
        };
        const iniciar = () => {
            if (window["pdfjs-dist/build/pdf"]) { carregar(); return; }
            const ex = document.getElementById("pdfjs-script");
            if (ex) { ex.addEventListener("load", carregar, { once: true }); return; }
            const s = document.createElement("script");
            s.id = "pdfjs-script";
            s.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
            s.onload = carregar; s.onerror = () => { setCarregando(false); setPaginas(["erro"]); };
            document.head.appendChild(s);
        };
        iniciar();
    }, [url]);

    const onScroll = () => {
        if (!scrollRef.current) return;
        const imgs = scrollRef.current.querySelectorAll("img[data-page]");
        for (const img of imgs) {
            const rect = img.getBoundingClientRect();
            if (rect.top >= 0 && rect.top < window.innerHeight * 0.6) { setPaginaAtual(Number(img.dataset.page)); break; }
        }
    };

    if (carregando) return (
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 14, background: "#0a0f1e" }}>
            <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
            <div style={{ width: 48, height: 48, border: `3px solid ${GOLD}22`, borderTop: `3px solid ${GOLD}`, borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
            <div style={{ fontSize: 13, color: "#ffffff50" }}>Carregando PDF... {progresso}%</div>
            <div style={{ width: 160, height: 4, background: "#ffffff10", borderRadius: 2 }}>
                <div style={{ width: `${progresso}%`, height: "100%", background: GOLD, borderRadius: 2, transition: "width 0.3s" }} />
            </div>
        </div>
    );

    if (paginas[0] === "erro") return (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, padding: 24 }}>
            <div style={{ fontSize: 52 }}>📄</div>
            <div style={{ fontSize: 14, color: "#ffffff50", textAlign: "center" }}>Não foi possível renderizar o PDF.<br/>Abra diretamente no navegador.</div>
            <a href={url} target="_blank" rel="noreferrer" style={{ background: GOLD, color: BLUE, padding: "12px 28px", borderRadius: 14, fontWeight: 800, fontSize: 15, textDecoration: "none" }}>📥 Abrir PDF</a>
        </div>
    );

    return (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: "#111" }}>
            <div style={{ background: "#0a0f1e", borderBottom: "1px solid #ffffff10", padding: "6px 14px", display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
                <span style={{ fontSize: 11, color: "#ffffff40" }}>Pág {paginaAtual}/{total}</span>
                <div style={{ flex: 1 }} />
                <button onClick={() => setZoom(z => Math.max(0.5, +(z - 0.25).toFixed(2)))} style={{ width: 30, height: 30, borderRadius: 8, border: "none", background: "#ffffff12", color: "white", fontSize: 18, cursor: "pointer" }}>−</button>
                <span style={{ fontSize: 11, color: GOLD, fontWeight: 700, minWidth: 38, textAlign: "center" }}>{Math.round(zoom * 100)}%</span>
                <button onClick={() => setZoom(z => Math.min(3, +(z + 0.25).toFixed(2)))} style={{ width: 30, height: 30, borderRadius: 8, border: "none", background: "#ffffff12", color: "white", fontSize: 18, cursor: "pointer" }}>+</button>
                <button onClick={() => setZoom(1)} style={{ padding: "4px 10px", borderRadius: 8, border: "none", background: "#ffffff12", color: "#ffffff60", fontSize: 10, cursor: "pointer" }}>Fit</button>
                <a href={url} target="_blank" rel="noreferrer" style={{ padding: "5px 12px", borderRadius: 8, background: GOLD, color: BLUE, fontSize: 11, fontWeight: 800, textDecoration: "none" }}>📥</a>
            </div>
            <div ref={scrollRef} onScroll={onScroll} style={{ flex: 1, overflowY: "auto", overflowX: "auto", background: "#222", padding: "10px 0" }}>
                {paginas.map((src, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
                        <img data-page={i + 1} src={src} alt={`Página ${i + 1}`}
                             style={{ width: `${zoom * 100}%`, maxWidth: "none", display: "block", borderRadius: 4, boxShadow: "0 2px 16px #0008" }} />
                    </div>
                ))}
                <div style={{ height: 20 }} />
            </div>
        </div>
    );
}


// ── Modal de Compartilhamento Visual ─────────────────────────────────────────

// ── Modal de Compartilhamento Visual ─────────────────────────────────────────
function ModalCompartilhar({ ev, visivel, onFechar }) {
    const canvasRef = useRef(null);
    const [gerado, setGerado] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const setlist = ev?.setlist || [];
    const integrantes = ev?.integrantes || [];

    const CORES_TIPO = {
        Culto: "#4a90d9", Célula: "#4caf50", Ensaio: "#F9A826",
        Conferência: "#9c27b0", Outro: "#607d8b",
    };
    const EMOJI_TIPO = {
        Culto: "✝", Célula: "🏠", Ensaio: "🎸", Conferência: "🎤", Outro: "📌",
    };
    const corTipo = CORES_TIPO[ev?.tipo] || "#F9A826";
    const emojiTipo = EMOJI_TIPO[ev?.tipo] || "🎵";

    useEffect(() => {
        if (!visivel || !canvasRef.current) return;
        setGerado(false);
        setImageUrl(null);

        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const W = 800, H = 1000;
        canvas.width = W;
        canvas.height = H;

        // Fundo
        const grad = ctx.createLinearGradient(0, 0, W, H);
        grad.addColorStop(0, "#0f1729");
        grad.addColorStop(0.5, "#1a2540");
        grad.addColorStop(1, "#0a0f1e");
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, W, H);

        // Círculos decorativos
        ctx.beginPath();
        ctx.arc(W * 0.85, -60, 200, 0, Math.PI * 2);
        ctx.fillStyle = corTipo + "18";
        ctx.fill();

        ctx.beginPath();
        ctx.arc(W * 0.1, H * 0.75, 160, 0, Math.PI * 2);
        ctx.fillStyle = "#F9A82610";
        ctx.fill();

        // Linha dourada lateral
        ctx.fillStyle = "#F9A826";
        ctx.fillRect(40, 0, 5, 130);

        // Badge tipo
        ctx.fillStyle = corTipo + "25";
        ctx.beginPath();
        ctx.roundRect(55, 38, 170, 38, 19);
        ctx.fill();
        ctx.strokeStyle = corTipo + "60";
        ctx.lineWidth = 1.5;
        ctx.stroke();

        ctx.fillStyle = corTipo;
        ctx.font = "bold 14px system-ui, sans-serif";
        ctx.textAlign = "left";
        const tipoLabel = (ev?.tipo || "EVENTO").toUpperCase();
        ctx.fillText(emojiTipo + "  " + tipoLabel, 75, 62);

        // Título
        ctx.fillStyle = "#ffffff";
        ctx.font = "bold 50px system-ui, sans-serif";
        ctx.textAlign = "left";
        const titulo = ev?.titulo || "";
        const maxW = W - 80;
        if (ctx.measureText(titulo).width > maxW) {
            const palavras = titulo.split(" ");
            let l1 = "", l2 = "";
            for (const p of palavras) {
                if (ctx.measureText(l1 + p + " ").width < maxW) l1 += p + " ";
                else l2 += p + " ";
            }
            ctx.fillText(l1.trim(), 55, 130);
            ctx.font = "bold 42px system-ui, sans-serif";
            ctx.fillText(l2.trim(), 55, 182);
        } else {
            ctx.fillText(titulo, 55, 148);
        }

        // Data
        ctx.fillStyle = "#ffffff88";
        ctx.font = "500 22px system-ui, sans-serif";
        ctx.fillText("📅  " + (ev?.dataFormatada || ""), 55, 218);

        // Divisor dourado
        const gradDiv = ctx.createLinearGradient(55, 0, W - 55, 0);
        gradDiv.addColorStop(0, "#F9A826");
        gradDiv.addColorStop(1, "#F9A82600");
        ctx.fillStyle = gradDiv;
        ctx.fillRect(55, 244, W - 110, 2);

        let y = 278;

        // Equipe
        if (integrantes.length > 0) {
            ctx.fillStyle = "#F9A826";
            ctx.font = "bold 12px system-ui, sans-serif";
            ctx.textAlign = "left";
            ctx.fillText("👥  EQUIPE ESCALADA", 55, y);
            y += 32;

            const nomes = integrantes.map(function(m) { return m.nome; });
            ctx.fillStyle = "#ffffffcc";
            ctx.font = "500 18px system-ui, sans-serif";

            let linhaAtual = "";
            const linhasNomes = [];
            for (const nome of nomes) {
                const tentativa = linhaAtual ? linhaAtual + "  ·  " + nome : nome;
                if (ctx.measureText(tentativa).width > W - 110) {
                    linhasNomes.push(linhaAtual);
                    linhaAtual = nome;
                } else {
                    linhaAtual = tentativa;
                }
            }
            if (linhaAtual) linhasNomes.push(linhaAtual);

            for (const ln of linhasNomes) {
                ctx.fillText(ln, 55, y);
                y += 26;
            }
            y += 16;

            ctx.fillStyle = "#ffffff18";
            ctx.fillRect(55, y, W - 110, 1);
            y += 22;
        }

        // Setlist
        if (setlist.length > 0) {
            ctx.fillStyle = "#F9A826";
            ctx.font = "bold 12px system-ui, sans-serif";
            ctx.textAlign = "left";
            ctx.fillText("🎵  ORDEM DAS MÚSICAS", 55, y);
            y += 30;

            const maxMusicas = Math.min(setlist.length, 7);
            for (let i = 0; i < maxMusicas; i++) {
                if (y > H - 170) break;
                const s = setlist[i];

                // Círculo numerado
                ctx.beginPath();
                ctx.arc(70, y - 6, 14, 0, Math.PI * 2);
                ctx.fillStyle = "#F9A82622";
                ctx.fill();
                ctx.strokeStyle = "#F9A82650";
                ctx.lineWidth = 1;
                ctx.stroke();
                ctx.fillStyle = "#F9A826";
                ctx.font = "bold 12px system-ui, sans-serif";
                ctx.textAlign = "center";
                ctx.fillText(String(i + 1), 70, y - 2);
                ctx.textAlign = "left";

                // Nome
                ctx.fillStyle = "#ffffff";
                ctx.font = "600 18px system-ui, sans-serif";
                ctx.fillText(s.titulo || "", 94, y - 2);

                // Subtítulo
                ctx.fillStyle = "#F9A826aa";
                ctx.font = "500 13px system-ui, sans-serif";
                const sub = s.autor ? s.autor + "  ·  Tom: " + s.tom : "Tom: " + s.tom;
                ctx.fillText(sub, 94, y + 16);

                y += 48;
            }
            if (setlist.length > 7) {
                ctx.fillStyle = "#ffffff40";
                ctx.font = "italic 14px system-ui, sans-serif";
                ctx.fillText("+ " + (setlist.length - 7) + " músicas...", 94, y);
            }
        }

        // Rodapé
        ctx.fillStyle = "#ffffff0d";
        ctx.fillRect(0, H - 80, W, 80);

        // Linha dourada rodapé
        const gradRodape = ctx.createLinearGradient(0, H - 80, W, H - 80);
        gradRodape.addColorStop(0, "#F9A82600");
        gradRodape.addColorStop(0.5, "#F9A826");
        gradRodape.addColorStop(1, "#F9A82600");
        ctx.fillStyle = gradRodape;
        ctx.fillRect(0, H - 80, W, 1);

        ctx.fillStyle = "#F9A826";
        ctx.font = "bold 22px system-ui, sans-serif";
        ctx.textAlign = "center";
        ctx.fillText("AdoraTeam", W / 2, H - 42);

        ctx.fillStyle = "#ffffff44";
        ctx.font = "500 12px system-ui, sans-serif";
        ctx.fillText("Gestão do seu ministério de louvor  ·  adorateam.com.br", W / 2, H - 20);

        setImageUrl(canvas.toDataURL("image/png"));
        setGerado(true);
    }, [visivel, ev]);

    const baixarOuCompartilharImagem = async () => {
        if (!imageUrl) return;
        try {
            const blob = await (await fetch(imageUrl)).blob();
            const file = new File([blob], "adorateam-escala.png", { type: "image/png" });
            const dadosShare = { files: [file], title: "Escala - " + (ev?.titulo || "") };
            if (navigator.canShare && navigator.canShare(dadosShare)) {
                await navigator.share(dadosShare);
            } else {
                const a = document.createElement("a");
                a.href = imageUrl;
                a.download = "adorateam-escala.png";
                a.click();
            }
        } catch (e) {
            if (e.name !== "AbortError") {
                const a = document.createElement("a");
                a.href = imageUrl;
                a.download = "adorateam-escala.png";
                a.click();
            }
        }
    };

    const compartilharTexto = async () => {
        const nomes = integrantes.map(function(m) { return m.nome; }).join(", ");
        const equipeStr = integrantes.length > 0 ? "\n👥 Equipe: " + nomes + "\n" : "";
        const musicasStr = setlist.map(function(s, i) {
            return (i + 1) + ". " + s.titulo + " (Tom: " + s.tom + ")";
        }).join("\n");
        const txt = "🎵 " + (ev?.titulo || "") + "\n📅 " + (ev?.dataFormatada || "") + equipeStr + "\n\n" + musicasStr + "\n\n_Gerado pelo AdoraTeam - adorateam.com.br_";
        try {
            if (navigator.share) {
                await navigator.share({ title: "Escala - " + (ev?.titulo || ""), text: txt });
            } else {
                await navigator.clipboard.writeText(txt);
                alert("Texto copiado!");
            }
        } catch (e) {
            if (e.name !== "AbortError") {
                await navigator.clipboard.writeText(txt).catch(function() {});
            }
        }
    };

    if (!visivel) return null;

    return createPortal(
        <div onClick={onFechar} style={{ position: "fixed", inset: 0, zIndex: 99999, background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 16 }}>
            <style>{`@keyframes shareUp { from { opacity:0; transform:translateY(30px) } to { opacity:1; transform:translateY(0) } }`}</style>
            <div onClick={function(e) { e.stopPropagation(); }} style={{ width: "100%", maxWidth: 400, background: "#1a2540", borderRadius: 24, border: "1px solid #2a3a5c", overflow: "hidden", boxShadow: "0 24px 60px rgba(0,0,0,0.7)", animation: "shareUp 0.3s ease" }}>
                <div style={{ padding: "16px 20px", background: "linear-gradient(135deg,#0f1729,#1a2540)", borderBottom: "1px solid #2a3a5c", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                        <div style={{ fontSize: 16, fontWeight: 800, color: "#fff" }}>Compartilhar escala</div>
                        <div style={{ fontSize: 12, color: "#8899bb", marginTop: 2 }}>Escolha como quer compartilhar</div>
                    </div>
                    <button onClick={onFechar} style={{ width: 32, height: 32, borderRadius: "50%", background: "#ffffff15", border: "none", color: "white", fontSize: 18, cursor: "pointer" }}>✕</button>
                </div>
                <div style={{ padding: "16px 20px 8px" }}>
                    <canvas ref={canvasRef} style={{ display: "none" }} />
                    {imageUrl ? (
                        <div style={{ borderRadius: 14, overflow: "hidden", border: "1px solid #2a3a5c", marginBottom: 4 }}>
                            <img src={imageUrl} alt="Preview da escala" style={{ width: "100%", display: "block" }} />
                        </div>
                    ) : (
                        <div style={{ height: 180, borderRadius: 14, background: "#0f1729", display: "flex", alignItems: "center", justifyContent: "center", color: "#8899bb", fontSize: 14, border: "1px solid #2a3a5c" }}>
                            Gerando cartão...
                        </div>
                    )}
                </div>
                <div style={{ padding: "12px 20px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
                    <button onClick={baixarOuCompartilharImagem} disabled={!gerado} style={{ width: "100%", padding: "14px 0", borderRadius: 14, background: gerado ? "linear-gradient(135deg,#F9A826,#FFD166)" : "#2a3a5c", border: "none", color: gerado ? "#0f1729" : "#8899bb", fontWeight: 800, fontSize: 15, cursor: gerado ? "pointer" : "default", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, boxShadow: gerado ? "0 4px 20px #F9A82644" : "none" }}>
                        <span style={{ fontSize: 18 }}>🖼️</span> Compartilhar como imagem
                    </button>
                    <button onClick={compartilharTexto} style={{ width: "100%", padding: "13px 0", borderRadius: 14, background: "#ffffff0d", border: "1px solid #2a3a5c", color: "#ffffffcc", fontWeight: 600, fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                        <span style={{ fontSize: 18 }}>💬</span> Compartilhar como texto
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

// ── Seção: Ordem das músicas ──────────────────────────────────────────────────
function OrdemMusicas({ ev, musicas, setEscala, onSalvarSetlist, adminMode, tema: T }) {
    const [adicionando, setAdicionando] = useState(false);
    const [busca, setBusca] = useState("");
    const [modoCulto, setModoCulto] = useState(false);
    const [modalCompartilhar, setModalCompartilhar] = useState(false);
    const dragItem = useRef(null);
    const dragOver = useRef(null);
    const touchStartY = useRef(null);
    const setlist = ev.setlist || [];

    const atualizar = (nova) => {
        setEscala(prev => prev.map(x => x.id === ev.id ? { ...x, setlist: nova } : x));
    };

    const adicionar = (m) => {
        if (setlist.find(s => s.id === m.id)) return;
        atualizar([...setlist, { id: m.id, titulo: m.titulo, tom: m.tom, autor: m.autor }]);
        setBusca("");
    };

    const remover = (id) => atualizar(setlist.filter(s => s.id !== id));

    const onDragStart = (i) => { dragItem.current = i; };
    const onDragEnter = (i) => { dragOver.current = i; };
    const onDragEnd = () => {
        const nova = [...setlist];
        const item = nova.splice(dragItem.current, 1)[0];
        nova.splice(dragOver.current, 0, item);
        dragItem.current = null; dragOver.current = null;
        atualizar(nova);
    };
    const onTouchStart = (e, i) => { touchStartY.current = e.touches[0].clientY; dragItem.current = i; };
    const onTouchEnd = (e, i) => {
        const diff = e.changedTouches[0].clientY - touchStartY.current;
        if (Math.abs(diff) > 40) {
            const nova = [...setlist];
            const dest = diff > 0 ? Math.min(i + 1, setlist.length - 1) : Math.max(i - 1, 0);
            const item = nova.splice(i, 1)[0];
            nova.splice(dest, 0, item);
            atualizar(nova);
        }
    };

    const compartilhar = async () => {
        const integrantes = ev.integrantes || [];
        const participantesStr = integrantes.length > 0
            ? `\n👥 *Equipe:* ${integrantes.map(m => m.nome).join(", ")}\n`
            : "";
        const txt = `🎵 *${ev.titulo}*\n📅 ${ev.dataFormatada}${participantesStr}\n\n${setlist.map((s, i) => `${i + 1}. ${s.titulo} (Tom: ${s.tom})`).join("\n")}\n\n_Enviado pelo AdoraTeam_`;
        const dados = {
            title: `Setlist — ${ev.titulo}`,
            text: txt,
        };
        try {
            if (navigator.share && navigator.canShare && navigator.canShare(dados)) {
                await navigator.share(dados);
            } else if (navigator.share) {
                await navigator.share(dados);
            } else {
                await navigator.clipboard.writeText(txt);
                // Feedback visual temporário
                const el = document.createElement("div");
                el.textContent = "✓ Copiado para área de transferência!";
                Object.assign(el.style, {
                    position: "fixed", bottom: "90px", left: "50%",
                    transform: "translateX(-50%)",
                    background: "rgba(76,175,80,0.95)", color: "white",
                    padding: "10px 20px", borderRadius: "12px",
                    fontWeight: "700", fontSize: "13px", zIndex: "99999",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
                    whiteSpace: "nowrap",
                });
                document.body.appendChild(el);
                setTimeout(() => el.remove(), 2500);
            }
        } catch (e) {
            if (e.name !== "AbortError") {
                await navigator.clipboard.writeText(txt).catch(() => {});
            }
        }
    };

    const musicasFiltradas = musicas
        .filter(m => !setlist.find(s => s.id === m.id))
        .filter(m => busca === "" || m.titulo.toLowerCase().includes(busca.toLowerCase()) || (m.autor || "").toLowerCase().includes(busca.toLowerCase()));

    return (
        <div>
            {modoCulto && <ModoCultoEvento setlist={setlist} musicasBase={musicas} onFechar={() => setModoCulto(false)} />}
            <ModalCompartilhar ev={ev} visivel={modalCompartilhar} onFechar={() => setModalCompartilhar(false)} />
            {/* Título da seção */}
            <div style={{ fontSize: 10, fontWeight: 700, color: T.textoSecundario, textTransform: "uppercase", letterSpacing: 1.2, marginBottom: 10 }}>
                🎵 Ordem das músicas
            </div>
            {/* Botões de ação — linha separada, sempre visível */}
            <div style={{ display: "flex", gap: 6, marginBottom: 12, flexWrap: "wrap" }}>
                {setlist.length > 0 && (
                    <>
                        <button onClick={() => setModoCulto(true)} style={{ flex: 1, background: `linear-gradient(135deg, #7B2FBE, #9c27b0)`, border: "none", borderRadius: 20, padding: "9px 12px", cursor: "pointer", color: "white", fontSize: 12, fontWeight: 700, boxShadow: "0 2px 10px #9c27b033", whiteSpace: "nowrap", lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 5 }}>
                            <span style={{ fontSize: 14, lineHeight: 1 }}>🎬</span> Modo Culto
                        </button>
                        <button onClick={() => setModalCompartilhar(true)} style={{ flex: 1, background: T.bgCardSecundario, border: `1px solid ${T.borda}`, borderRadius: 20, padding: "9px 12px", cursor: "pointer", color: T.textoSecundario, fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center", gap: 5, whiteSpace: "nowrap", lineHeight: 1.2 }}>
                            <span style={{ fontSize: 14 }}>↑</span> Compartilhar
                        </button>
                    </>
                )}
                {adminMode && (
                    <button onClick={() => { setAdicionando(p => !p); setBusca(""); }}
                            style={{ flex: setlist.length > 0 ? "0 0 auto" : 1, background: adicionando ? T.bgCardSecundario : `${GOLD}22`, border: `1px solid ${adicionando ? T.borda : `${GOLD}44`}`, borderRadius: 20, padding: "8px 14px", cursor: "pointer", color: adicionando ? T.textoSecundario : GOLD, fontSize: 12, fontWeight: 700 }}>
                        {adicionando ? "✕ Fechar" : "+ Música"}
                    </button>
                )}
            </div>
            {setlist.length === 0 && !adicionando && <div style={{ fontSize: 12, color: T.textoSecundario }}>Nenhuma música na ordem ainda</div>}
            {setlist.map((s, i) => (
                <div key={s.id} draggable={adminMode}
                     onDragStart={() => adminMode && onDragStart(i)} onDragEnter={() => adminMode && onDragEnter(i)} onDragEnd={() => adminMode && onDragEnd()}
                     onTouchStart={e => adminMode && onTouchStart(e, i)} onTouchEnd={e => adminMode && onTouchEnd(e, i)}
                     style={{ display: "flex", alignItems: "center", gap: 10, background: T.bgCardSecundario, borderRadius: 10, padding: "10px 12px", marginBottom: 6, border: `1px solid ${T.borda}`, cursor: adminMode ? "grab" : "default" }}>
                    <div style={{ width: 26, height: 26, borderRadius: "50%", background: `${GOLD}20`, border: `1px solid ${GOLD}40`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800, color: GOLD, flexShrink: 0 }}>{i + 1}</div>
                    {adminMode && <span style={{ color: T.textoSecundario, fontSize: 14 }}>☰</span>}
                    <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 700, color: T.texto }}>{s.titulo}</div>
                        <div style={{ fontSize: 10 }}>
                            {s.autor && <span style={{ color: T.textoSecundario }}>{s.autor} · </span>}
                            <span style={{ color: GOLD }}>Tom: {s.tom}</span>
                        </div>
                    </div>
                    {adminMode && (
                        <button onClick={() => remover(s.id)} style={{ background: "#ff000018", border: "none", borderRadius: 8, padding: "4px 8px", cursor: "pointer", fontSize: 13, color: "#ff6b6b" }}>🗑</button>
                    )}
                </div>
            ))}
            {adicionando && (
                <div style={{ background: T.bgCardSecundario, borderRadius: 14, padding: 12, border: `1px solid ${T.borda}`, marginTop: 8 }}>
                    <input placeholder="🔍 Buscar por nome ou artista..." value={busca} onChange={e => setBusca(e.target.value)}
                           style={{ width: "100%", padding: "8px 12px", borderRadius: 10, border: `1px solid ${T.borda}`, background: T.bgCard, color: T.texto, fontSize: 13, marginBottom: 10, boxSizing: "border-box", outline: "none" }} />
                    {busca && !musicasFiltradas.length && (
                        <button onClick={() => { atualizar([...setlist, { id: Date.now(), titulo: busca, tom: "C", autor: "" }]); setBusca(""); }}
                                style={{ width: "100%", padding: "10px 12px", borderRadius: 10, background: `${GOLD}15`, border: `1px solid ${GOLD}44`, cursor: "pointer", textAlign: "left", marginBottom: 6, color: GOLD, fontSize: 13, fontWeight: 700 }}>
                            ➕ Adicionar "{busca}" como nova entrada
                        </button>
                    )}
                    {musicasFiltradas.length === 0 && !busca && <div style={{ fontSize: 12, color: T.textoSecundario, textAlign: "center", padding: "8px 0" }}>Todas as músicas já foram adicionadas!</div>}
                    {musicasFiltradas.map(m => (
                        <button key={m.id} onClick={() => adicionar(m)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, background: T.bgCard, borderRadius: 10, padding: "10px 12px", marginBottom: 6, border: `1px solid ${T.borda}`, cursor: "pointer", textAlign: "left" }}>
                            <div style={{ width: 32, height: 32, borderRadius: 8, background: `${GOLD}18`, border: `1px solid ${GOLD}30`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>🎵</div>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: 13, fontWeight: 700, color: T.texto }}>{m.titulo}</div>
                                <div style={{ fontSize: 10, color: T.textoSecundario }}>{m.autor && <span>{m.autor} · </span>}<span style={{ color: GOLD }}>Tom: {m.tom}</span></div>
                            </div>
                            <span style={{ color: GOLD, fontSize: 18, fontWeight: 300 }}>+</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

// ── Card do evento ────────────────────────────────────────────────────────────
function EventoCard({ ev, musicas, membros, setEscala, adminMode, perfilNome, onSalvarSetlist, onSolicitarExclusao, tema: T, idx }) {
    const [expanded, setExpanded] = useState(false);
    const [editandoTitulo, setEditandoTitulo] = useState(false);
    const [tituloEdit, setTituloEdit] = useState(ev.titulo);
    const [salvandoEvento, setSalvandoEvento] = useState(false);
    const [salvoEventoOk, setSalvoEventoOk] = useState(false);
    const cfg = TIPO_CONFIG[ev.tipo] || TIPO_CONFIG["Outro"];
    const { passado, urgente } = diasRestantes(ev.data);
    const integrantes = ev.integrantes || [];

    // Salva o evento completo chamando as rotas corretas do backend
    const salvarEvento = async () => {
        setSalvandoEvento(true);
        try {
            // 1. Salva dados gerais (título, tipo, data, paleta)
            await eventosAPI.atualizar(ev.id, {
                titulo: tituloEdit,
                tipo: ev.tipo,
                data: ev.data,
                fotoPaleta: ev.fotoPaleta || null,
                responsavelPaleta: ev.responsavelPaleta || null,
            });

            // 2. Salva equipe escalada
            await eventosAPI.atualizarMembros(ev.id, ev.integrantes || []);

            // 3. Salva setlist
            await eventosAPI.atualizarSetlist(ev.id, ev.setlist || []);

            // Atualiza título no estado local
            setEscala(prev => prev.map(x => x.id === ev.id ? { ...x, titulo: tituloEdit } : x));
            setEditandoTitulo(false);
            setSalvoEventoOk(true);
            setTimeout(() => setSalvoEventoOk(false), 2500);
        } catch (e) {
            alert("Erro ao salvar evento: " + (e.message || "tente novamente"));
        } finally {
            setSalvandoEvento(false);
        }
    };

    return (
        <div style={{
            borderRadius: 20, overflow: "hidden",
            border: `1px solid ${passado ? T.borda : (T.bg === "#f0f2f8" ? T.borda : "#ffffff18")}`,
            marginBottom: 14, opacity: passado ? 0.65 : 1,
            boxShadow: passado ? "none" : "0 8px 32px rgba(0,0,0,0.35)",
            animation: "escalaSlideUp 0.35s ease both",
            animationDelay: `${idx * 0.07}s`,
        }}>
            {/* Header */}
            <div onClick={() => setExpanded(p => !p)} style={{
                background: `linear-gradient(${cfg.grad})`,
                padding: "18px 18px 16px", cursor: "pointer",
                position: "relative", overflow: "hidden",
            }}>
                <div style={{ position: "absolute", top: -20, right: -20, width: 110, height: 110, borderRadius: "50%", background: `${cfg.accent}12`, pointerEvents: "none" }} />
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <div style={{ width: 32, height: 32, borderRadius: 10, background: `${cfg.accent}20`, border: `1px solid ${cfg.accent}40`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>{cfg.icon}</div>
                        <span style={{ fontSize: 11, fontWeight: 700, color: cfg.accent, textTransform: "uppercase", letterSpacing: 1.2 }}>{ev.tipo || "Evento"}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <BadgeDias data={ev.data} />
                        {adminMode && (
                            // FIX: chama modal de confirmação em vez de deletar direto
                            <button
                                onClick={e => { e.stopPropagation(); onSolicitarExclusao(ev); }}
                                style={{ background: "#ff000018", border: "1px solid #ff000028", borderRadius: 8, width: 28, height: 28, cursor: "pointer", fontSize: 11, color: "#ff6b6b", display: "flex", alignItems: "center", justifyContent: "center" }}
                                title="Excluir evento"
                            >✕</button>
                        )}
                    </div>
                </div>
                <div style={{ marginBottom: 14 }}>
                    <div style={{ fontSize: 20, fontWeight: 800, color: "#fff", letterSpacing: -0.5, lineHeight: 1.2, marginBottom: 5 }}>
                        {tituloEdit}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 13, color: "#ffffff70" }}>📅 {ev.dataFormatada}</span>
                        {urgente && !passado && (
                            <span style={{ fontSize: 10, background: `${GOLD}20`, color: GOLD, padding: "2px 8px", borderRadius: 10, fontWeight: 700, border: `1px solid ${GOLD}30` }}>⚡ Em breve</span>
                        )}
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {integrantes.slice(0, 5).map((m, i) => <Avatar key={i} membro={m} size={28} overlap={i > 0} />)}
                        {integrantes.length > 5 && (
                            <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#ffffff12", border: "2px solid #0f1729", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, color: "#ffffff70", fontWeight: 700, marginLeft: -8 }}>+{integrantes.length - 5}</div>
                        )}
                        {integrantes.length > 0 && <span style={{ fontSize: 11, color: "#ffffff40", marginLeft: 10 }}>{integrantes.length} {integrantes.length === 1 ? "membro" : "membros"}</span>}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {ev.setlist?.length > 0 && <span style={{ fontSize: 11, color: `${GOLD}99` }}>🎵 {ev.setlist.length}</span>}
                        {ev.fotoPaleta
                            ? <span style={{ fontSize: 12, background: "#ffffff15", borderRadius: 20, padding: "2px 8px", color: "#ffffffaa" }}>👗 Look definido</span>
                            : ev.responsavelPaleta
                                ? <span style={{ fontSize: 11, color: `${GOLD}88`, background: `${GOLD}12`, borderRadius: 20, padding: "2px 8px", border: `1px solid ${GOLD}25` }}>👗 Aguardando look</span>
                                : null
                        }
                    </div>
                </div>
                <div style={{ position: "absolute", bottom: 16, right: 18, color: "#ffffff25", fontSize: 12, transform: expanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.25s" }}>▼</div>
            </div>

            {/* Conteúdo expandido */}
            {expanded && (
                <div style={{ background: T.bgCard, borderTop: `1px solid ${T.borda}`, padding: "18px" }}>

                    {/* Edição do nome + Salvar Evento */}
                    {adminMode && (
                        <div style={{ marginBottom: 18 }}>
                            <div style={{ fontSize: 11, color: T.textoSecundario, fontWeight: 600, marginBottom: 6, textTransform: "uppercase", letterSpacing: 1 }}>✏️ Nome do evento</div>
                            <input
                                value={tituloEdit}
                                onChange={e => setTituloEdit(e.target.value)}
                                placeholder="Nome do evento"
                                style={{
                                    width: "100%", padding: "10px 14px",
                                    borderRadius: 12, boxSizing: "border-box",
                                    border: `1px solid ${GOLD}44`,
                                    background: T.bgCardSecundario,
                                    color: T.texto, fontSize: 15, fontWeight: 700,
                                    outline: "none", marginBottom: 10,
                                }}
                            />
                            <button
                                onClick={salvarEvento}
                                disabled={salvandoEvento}
                                style={{
                                    width: "100%", padding: "11px 0",
                                    borderRadius: 12,
                                    background: salvoEventoOk
                                        ? "linear-gradient(135deg,#4caf50,#388e3c)"
                                        : `linear-gradient(135deg,${GOLD},#FFD166)`,
                                    border: "none", cursor: salvandoEvento ? "default" : "pointer",
                                    color: salvoEventoOk ? "white" : BLUE,
                                    fontWeight: 800, fontSize: 14,
                                    boxShadow: salvandoEvento ? "none" : `0 4px 16px ${GOLD}44`,
                                    transition: "all 0.3s",
                                    opacity: salvandoEvento ? 0.7 : 1,
                                }}
                            >
                                {salvandoEvento ? "Salvando..." : salvoEventoOk ? "✓ Evento salvo!" : "💾 Salvar evento"}
                            </button>
                        </div>
                    )}

                    <PaletaCores ev={ev} setEscala={setEscala} adminMode={adminMode} perfilNome={perfilNome} tema={T} />
                    <div style={{ height: 1, background: T.borda, marginBottom: 18 }} />
                    <EquipeEvento ev={ev} membros={membros} setEscala={setEscala} adminMode={adminMode} tema={T} />
                    <div style={{ height: 1, background: T.borda, marginBottom: 18 }} />
                    <OrdemMusicas ev={ev} musicas={musicas} setEscala={setEscala} onSalvarSetlist={onSalvarSetlist} adminMode={adminMode} tema={T} />
                </div>
            )}
        </div>
    );
}

// ── Gerenciador de Membros ────────────────────────────────────────────────────
function GerenciarMembros({ membros, setMembros, adminMode, tema: T }) {
    const [aberto, setAberto] = useState(false);

    const remover = (id) => {
        setMembros(prev => prev.filter(m => m.id !== id));
    };

    return (
        <div style={{ marginBottom: 20 }}>
            <button onClick={() => setAberto(p => !p)} style={{
                width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
                background: T.bgCard, border: `1px solid ${T.borda}`, borderRadius: 14,
                padding: "14px 16px", cursor: "pointer", marginBottom: aberto ? 10 : 0,
            }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 10, background: `${GOLD}18`, border: `1px solid ${GOLD}30`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>👥</div>
                    <div style={{ textAlign: "left" }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: T.texto }}>Membros do ministério</div>
                        <div style={{ fontSize: 11, color: T.textoSecundario }}>
                            {membros.length === 0 ? "Nenhum cadastrado" : `${membros.length} cadastrado${membros.length > 1 ? "s" : ""}`}
                        </div>
                    </div>
                </div>
                <span style={{ color: T.textoSecundario, fontSize: 12, transform: aberto ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>▼</span>
            </button>

            {aberto && (
                <div style={{ background: T.bgCard, borderRadius: 14, border: `1px solid ${T.borda}`, overflow: "hidden" }}>
                    {membros.length > 0 && (
                        <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.borda}` }}>
                            {membros.map((m, idx) => (
                                <div key={m.id} style={{
                                    display: "flex", alignItems: "center", gap: 10,
                                    paddingBottom: idx < membros.length - 1 ? 10 : 0,
                                    marginBottom: idx < membros.length - 1 ? 10 : 0,
                                    borderBottom: idx < membros.length - 1 ? `1px solid ${T.borda}` : "none",
                                }}>
                                    <div style={{ width: 38, height: 38, borderRadius: "50%", overflow: "hidden", border: `2px solid ${GOLD}44`, flexShrink: 0, background: `${GOLD}18`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>
                                        {m.foto ? <img src={m.foto} alt={m.nome} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : "🎵"}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: 14, fontWeight: 700, color: T.texto }}>{m.nome}</div>
                                        <div style={{ fontSize: 11, color: GOLD }}>{m.funcao}</div>
                                    </div>
                                    {adminMode && (
                                        <button onClick={() => remover(m.id)} style={{ background: "#fce4ec", border: "none", borderRadius: 8, padding: "5px 8px", cursor: "pointer", fontSize: 13 }}>🗑</button>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                    {membros.length === 0 && (
                        <div style={{ padding: "20px 16px", textAlign: "center", color: T.textoSecundario, fontSize: 13 }}>
                            Nenhum membro no grupo ainda
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

function Separador({ label, tema: T }) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14, marginTop: 6 }}>
            <div style={{ flex: 1, height: 1, background: T ? T.borda : "#ffffff10" }} />
            <span style={{ fontSize: 10, color: T ? T.textoSecundario : "#ffffff30", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1.2 }}>{label}</span>
            <div style={{ flex: 1, height: 1, background: T ? T.borda : "#ffffff10" }} />
        </div>
    );
}

// ── Escala (componente principal) ─────────────────────────────────────────────
export default function Escala({ escala, setEscala, musicas, membros, setMembros, adminMode, perfilNome, onSalvarSetlist, tema }) {
    const T = TEMAS[tema];
    const [showForm, setShowForm] = useState(false);

    // FIX: estado do modal de confirmação de exclusão
    const [modalExclusao, setModalExclusao] = useState({ visivel: false, evento: null, loading: false });

    const [criandoEvento, setCriandoEvento] = useState(false);

    const salvarEvento = async (dadosForm) => {
        setCriandoEvento(true);
        try {
            const resposta = await eventosAPI.criar({
                titulo: dadosForm.titulo,
                tipo: dadosForm.tipo,
                data: dadosForm.data,
                integrantes: dadosForm.integrantes || [],
                setlist: dadosForm.setlist || [],
            });
            // Backend retorna { mensagem, evento } com UUID real
            const eventoReal = resposta.evento || dadosForm;
            if (!eventoReal.dataFormatada) {
                const [ano, mes, dia] = eventoReal.data.split("-");
                eventoReal.dataFormatada = `${dia}/${mes}/${ano}`;
            }
            eventoReal.integrantes = eventoReal.integrantes || dadosForm.integrantes || [];
            eventoReal.setlist = eventoReal.setlist || dadosForm.setlist || [];
            setEscala(prev => [...prev, eventoReal].sort((a, b) => new Date(a.data) - new Date(b.data)));
            setShowForm(false);
        } catch (e) {
            alert("Erro ao criar evento: " + (e.message || "tente novamente"));
        } finally {
            setCriandoEvento(false);
        }
    };

    // FIX: abre o modal (não deleta direto)
    const solicitarExclusao = (ev) => {
        setModalExclusao({ visivel: true, evento: ev, loading: false });
    };

    // FIX: confirma exclusão — chama API e atualiza estado local
    const confirmarExclusao = async () => {
        const ev = modalExclusao.evento;
        if (!ev) return;
        setModalExclusao(p => ({ ...p, loading: true }));
        try {
            await eventosAPI.apagar(ev.id);
            setEscala(prev => prev.filter(x => x.id !== ev.id));
            setModalExclusao({ visivel: false, evento: null, loading: false });
        } catch (e) {
            alert("Erro ao excluir evento: " + (e.message || "tente novamente"));
            setModalExclusao(p => ({ ...p, loading: false }));
        }
    };

    const cancelarExclusao = () => {
        if (modalExclusao.loading) return;
        setModalExclusao({ visivel: false, evento: null, loading: false });
    };

    const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
    const futuros  = escala.filter(e => new Date(e.data + "T00:00:00") >= hoje);
    const passados = escala.filter(e => new Date(e.data + "T00:00:00") < hoje);

    return (
        <div style={{ padding: "16px 16px 100px", minHeight: "100vh", background: T.bg }}>
            <style>{`
                @keyframes escalaSlideUp {
                    from { opacity: 0; transform: translateY(14px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
            `}</style>

            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 22 }}>
                <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: GOLD, textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 4 }}>Ministério de Louvor</div>
                    <div style={{ fontSize: 26, fontWeight: 900, color: T.texto, letterSpacing: -1 }}>Escala</div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {escala.length > 0 && (
                        <div style={{ fontSize: 11, color: T.textoSecundario, background: T.bgCard, border: `1px solid ${T.borda}`, borderRadius: 20, padding: "4px 10px" }}>
                            {escala.length} evento{escala.length !== 1 ? "s" : ""}
                        </div>
                    )}
                    {adminMode && (
                        <button onClick={() => setShowForm(p => !p)} style={{
                            background: showForm ? T.bgCard : `linear-gradient(135deg, ${GOLD}, #FFD166)`,
                            border: showForm ? `1px solid ${T.borda}` : "none",
                            borderRadius: 20, padding: "8px 18px", cursor: "pointer",
                            color: showForm ? T.texto : BLUE, fontWeight: 700, fontSize: 13,
                            boxShadow: showForm ? "none" : `0 4px 16px ${GOLD}44`,
                        }}>
                            {showForm ? "✕ Fechar" : "+ Novo"}
                        </button>
                    )}
                </div>
            </div>


            {showForm && (
                <div style={{ marginBottom: 20 }}>
                    <NovoEvento
                        onSalvar={salvarEvento}
                        onCancelar={() => setShowForm(false)}
                        membros={membros}
                        tema={T}
                        loading={criandoEvento}
                    />
                </div>
            )}

            {escala.length === 0 && !showForm && (
                <div style={{ textAlign: "center", padding: "50px 20px", background: T.bgCard, borderRadius: 20, border: `1px dashed ${T.borda}` }}>
                    <div style={{ fontSize: 44, marginBottom: 10 }}>📅</div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: T.textoSecundario, marginBottom: 6 }}>Nenhum evento ainda</div>
                    <div style={{ fontSize: 13, color: T.textoSecundario, opacity: 0.6 }}>
                        {adminMode ? 'Clique em "+ Novo" para criar.' : "O admin ainda não criou eventos."}
                    </div>
                </div>
            )}

            {futuros.length > 0 && (
                <>
                    {passados.length > 0 && <Separador label="Próximos eventos" tema={T} />}
                    {futuros.map((ev, i) => (
                        <EventoCard key={ev.id} ev={ev} idx={i} musicas={musicas} membros={membros}
                                    setEscala={setEscala} adminMode={adminMode} perfilNome={perfilNome}
                                    onSalvarSetlist={onSalvarSetlist}
                                    onSolicitarExclusao={solicitarExclusao}
                                    tema={T} />
                    ))}
                </>
            )}

            {passados.length > 0 && (
                <>
                    <Separador label="Eventos anteriores" tema={T} />
                    {passados.map((ev, i) => (
                        <EventoCard key={ev.id} ev={ev} idx={i} musicas={musicas} membros={membros}
                                    setEscala={setEscala} adminMode={adminMode} perfilNome={perfilNome}
                                    onSalvarSetlist={onSalvarSetlist}
                                    onSolicitarExclusao={solicitarExclusao}
                                    tema={T} />
                    ))}
                </>
            )}

            {/* Modal de confirmação de exclusão */}
            <ModalConfirmarExclusao
                visivel={modalExclusao.visivel}
                titulo="Excluir evento"
                descricao={`Tem certeza que deseja excluir "${modalExclusao.evento?.titulo}"? Essa ação não pode ser desfeita.`}
                onConfirmar={confirmarExclusao}
                onCancelar={cancelarExclusao}
                loading={modalExclusao.loading}
            />
        </div>
    );
}